"use strict";

var _toConsumableArray = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.between = function (min, max, val) {
  if (typeof min !== 'number' || typeof max !== 'number' || typeof val !== 'number') throw new Error('TypeError: One or more of the arguments are not numbers');
  if (val < min || val > max) return false;
  return true;
};

exports.consecutives = function (numbers) {
  if (numbers.length <= 1) return true;

  var numbersArray = _toConsumableArray(numbers);

  numbersArray.sort(function (a, b) {
    return a - b;
  });
  var prevNumber = numbersArray[0];
  return numbersArray.reduce(function (p, c) {
    var cons = p && (prevNumber + 1 === c || c === prevNumber);
    prevNumber = c;
    return cons;
  }, true);
};

var NUMBER_UTILS = {
  between: exports.between,
  consecutives: exports.consecutives
};
exports.default = NUMBER_UTILS;